/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Button, Col, Row} from "react-bootstrap";

import {BsCheckLg, BsExclamationLg} from "react-icons/all";

import {BeatLoader} from "react-spinners";


type MonitoryNoteSubmitStatusProps = {
    STATUS: 0 | 1 | -1 | -2;
    MESSAGE: string;
    SUCCESS_STATUS_BUTTON_HANDLER(): void;
    ERROR_STATUS_BUTTON_HANDLER(status: number): void;
};

export const MonitoryNoteSubmitStatusComponent: React.FC<MonitoryNoteSubmitStatusProps> = ({
    STATUS, MESSAGE,
    SUCCESS_STATUS_BUTTON_HANDLER, ERROR_STATUS_BUTTON_HANDLER
}) : JSX.Element | null => {


    const STATUS_BUTTON_HANDLER = () => {
        if (STATUS === 1) {
            return SUCCESS_STATUS_BUTTON_HANDLER();
        } else if (STATUS === -1) {
            return ERROR_STATUS_BUTTON_HANDLER(-1);
        }
        return ERROR_STATUS_BUTTON_HANDLER(0);
    };


    return (
        <Col xs={12} className={"monitory-note-submit-status-component monitory-note-submit-status"}>
            <Row className={"monitory-note-submit-status-content"}>

                <Col xs={12} className={"submit-status-information" + ((STATUS === 0 || STATUS === 1) ? " success" : " error")}>
                    {STATUS === 0 && <span>{MESSAGE}</span>}
                    {STATUS === 0 && <span><BeatLoader color={"#55Af3C"} /></span>}
                    {STATUS === 1 && <BsCheckLg />}
                    {STATUS === -1 || STATUS === -2 && <BsExclamationLg />}
                </Col>

                {(STATUS === 1 || STATUS === -1 || STATUS === -2) &&
	            <Col xs={12} className={"submit-status-final-message"}>
                    <span>{MESSAGE}</span>
	            </Col>
                }

                {(STATUS === 1 || STATUS === -1 || STATUS === -2) &&
	            <Col xs={12} className={"submit-status-button"}>
		            <Button onClick={STATUS_BUTTON_HANDLER}>
			            <span>{`ok`}</span>
		            </Button>
	            </Col>
                }

            </Row>
        </Col>
    );

};


export default MonitoryNoteSubmitStatusComponent;
